import React, { useState, useEffect, useContext } from 'react';
import "../../App.scss"
import RadientBorder from '../../../../Common/Global/RadientBorder/RadientBorder';
import "./ValidateOtp.scss"
import Button from '../../../../Common/Global/Button';
import OTPInput from 'react-otp-input';
import LoginServiceObject from "../../../../Common/services/Login"
import DataMapping from '../../../../Common/context/data-mapping/data-mapping';
import { STOREDATA } from '../../../../Common/context/data-mapping/action/action.type';
import { useLocation, useNavigate } from "react-router-dom";
import CreditScoreServiceObject from '../../../../Common/services/CreditScore';
import FailurePopUp from "../../../../Common/Global/FailurePopUp"
import OkButtonPopUp from '../../../../Common/Global/OkButtonPopUp';
import configUrlObj from '../../../../Common/Configuration';
import commonFunctionObject from '../../../../Common/common-function';


const ValidateOtp = () => {
    const [data, dispatchData] = useContext(DataMapping)
    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState("");
    const [resendOtp, setResendOtp] = useState(false);
    const [otpTimer, setOTPTimer] = useState(30);
    const [count, setCount] = useState(1);
    const [failurePopUpModal, setFailurePopUpModal] = useState(false);
    const [failurePopUpContent, setFailurePopUpContent] = useState({
        "apiName": "",
        "message": "",
        "errorCode": ""
    })
    const [okButtonPopUpFlag, setOkButtonPopUpFlag] = useState(false)
    const [okButtonPopUpContent, setOkButtonPopUpContent] = useState("")

    const navigate = useNavigate()
    const location = useLocation();
    //otp timer
    const handleOtpTimer = () => {
        setOTPTimer((oldState) => {
            if (oldState) {
                return oldState - 1
            } else {
                clearInterval(interval);
                setResendOtp(true);
                return 0
            }
        })
    }

    var mobileNo;
    var refId
    if (data?.urlParameter?.src === "website" || data?.urlParameter?.src ==="pgs") {
        if (location?.state?.postlogin === true) {
            mobileNo = location?.state?.singleActionRequestJson?.body?.mobileNumber;
            refId = location?.state?.refID
        } else {

            var { gcid, mobileNo, refId, status } = data?.generateMobResponse;
        }

    } else {
        mobileNo = location?.state?.singleActionRequestJson?.body?.mobileNumber
        refId = location?.state?.refID
    }

    let interval
    useEffect(() => {
        interval = setInterval(() => handleOtpTimer(), 1000);
        return () => clearInterval(interval);
    }, [otpTimer]);

    useEffect(() => {
        if (otp != "") {
            if (otp.length === 6) {
                if (otpError == "") {
                    validateOtpApiCall();
                    setOtpError("");
                } else {
                    setOtpError("Please enter a valid OTP");
                }
            }
        }

    }, [otp])

    useEffect(() => {
        commonFunctionObject.scrollToTop()
    }, [])

    const singleActionApiCall = () => {
        const singleActionRequestObject = location?.state?.singleActionRequestJson
        dispatchData({
            name: "loaderFlag",
            payload: true,
            type: STOREDATA
        })
        CreditScoreServiceObject.singleActionApiService(singleActionRequestObject).then((singleActionResponse) => {
            dispatchData({
                name: "loaderFlag",
                payload: false,
                type: STOREDATA
            })
            dispatchData({
                type: STOREDATA,
                name: "singleActionResponse",
                payload: singleActionResponse
            })
            dispatchData({
                type: STOREDATA,
                name: "mobileotpCalled",
                payload: false
            })
            navigate("/credit-score",{ state: { postlogin: true, singleActionResponse: singleActionRequestObject}});
        }).catch((error) => {
            if (error) {
                setOkButtonPopUpContent(error)
                setOkButtonPopUpFlag(true)
                dispatchData({
                    name: "loaderFlag",
                    payload: false,
                    type: STOREDATA
                })

                if(data?.mobileotpCalled == true){
                    dispatchData({
                        type: STOREDATA,
                        name: "mobileotpCalled",
                        payload: true
                    })
                }else{
                    dispatchData({
                        type: STOREDATA,
                        name: "mobileotpCalled",
                        payload: false
                    })
                }
            }
        })
    }

    //validateOtp API Call
    const validateOtpApiCall = () => {
        let requestObj = {
            header: {
                grantType: "otp",
                serviceType: "mobile",
                authToken: configUrlObj.authToken[configUrlObj.environment],
                journeyType: "postLogin",
            },
            body: {
                mobileNo: mobileNo,
                otpRef: refId,
                otp: otp,
            },
        };
        commonFunctionObject._setCookie('Authorization', configUrlObj.authToken[configUrlObj.environment]);

        dispatchData({
            name: "loaderFlag",
            payload: true,
            type: STOREDATA
        })
        LoginServiceObject.validateOtpService(requestObj).then(response => {
            console.log(response)
            dispatchData({
                name: "loaderFlag",
                payload: false,
                type: STOREDATA
            })
            dispatchData({
                type: STOREDATA,
                name: "mobileotpCalled",
                payload: true
            })
            if (data?.urlParameter?.src === "website" || data?.urlParameter?.src === "pgs") {
                if (!location?.state && status == "login") {
                    let requestObj = {
                        "header": {
                            "type": "gcid",
                            "authToken": configUrlObj.authToken[configUrlObj.environment]
                        },
                        "body": {
                            "username": gcid
                        }
                    }
                    commonFunctionObject._setCookie('Authorization', configUrlObj.authToken[configUrlObj.environment]);
                    dispatchData({
                        name: "loaderFlag",
                        payload: true,
                        type: STOREDATA
                    })
                    LoginServiceObject.getUserDataService(requestObj).then((getUserDataResponse) => {
                        dispatchData({
                            name: "loaderFlag",
                            payload: false,
                            type: STOREDATA
                        });
                        dispatchData({
                            type: STOREDATA,
                            name: "getUserDataResponse",
                            payload: getUserDataResponse.body
                        })
                        navigate("/personal-details")
                    }).catch((error) => {
                        dispatchData({
                            name: "loaderFlag",
                            payload: false,
                            type: STOREDATA
                        })
                        setFailurePopUpContent({
                            apiName: "",
                            message: "We Are Experiencing Technical Difficulty. Please Try After Sometime.",
                            errorCode: error
                        })
                        setFailurePopUpModal(true);
                    })
                } else {
                    if (location?.state) {
                        singleActionApiCall();
                    }
                }
            } else if (data?.urlParameter?.src === "moneyfy") {
                if (location?.state) {
                    dispatchData({
                        type: STOREDATA,
                        name: "mobileotpCalled",
                        payload: true
                    })
                    singleActionApiCall();
                }
            }
        }).catch((error) => {
            dispatchData({
                name: "loaderFlag",
                payload: false,
                type: STOREDATA
            })
            if (error == "invalid otp") {
                setOtpError("Incorrect OTP Entered")
            }
            if (error !== "invalid otp") {
                setFailurePopUpContent({
                    apiName: "",
                    message: error,
                    errorCode: error
                })
                setFailurePopUpModal(true);
            }

        })
    }

    const handleChange = (otp) => {
        setOtpError("");
        setOtp(otp);
    };

    //Resend Otp
    const validateOtpResendHandler = () => {
        setOtp("");
        setOtpError("")
        setCount(count + 1)
        if (count <= 3) {
            let reqObj = {
                "header": {
                    "grantType": "otp",
                    "serviceType": "mobile",
                    "authToken": configUrlObj.authToken[configUrlObj.environment],
                    "journeyType": "postLogin"
                },
                "body": {
                    "mobileNo": mobileNo
                }
            }
            commonFunctionObject._setCookie('Authorization', configUrlObj.authToken[configUrlObj.environment]);
            dispatchData({
                name: "loaderFlag",
                payload: true,
                type: STOREDATA
            })
            LoginServiceObject.generateMobOtpService(reqObj).then((generateMobileOtpResonse) => {
                dispatchData({
                    name: "loaderFlag",
                    payload: false,
                    type: STOREDATA
                })
                setOTPTimer(30);
                console.log(generateMobileOtpResonse);
            }).catch((error) => {
                dispatchData({
                    name: "loaderFlag",
                    payload: false,
                    type: STOREDATA
                })
                setFailurePopUpContent({
                    apiName: "",
                    message: "We Are Experiencing Technical Difficulty. Please Try After Sometime.",
                    errorCode: error
                })
                setFailurePopUpModal(true)
            })
        } else {
            setFailurePopUpContent({
                apiName: "",
                message: "Resend OTP can be attempted only thrice.",
                errorCode: ""
            })
            setFailurePopUpModal(true);
        }
    }

    //display mobile number

    const discardedMobile = mobileNo?.slice(2, 6);
    const discardedMobileArray = discardedMobile?.split("");
    const discardedMobileMap = discardedMobileArray?.map((item) => "*");
    const discardedMobileString = discardedMobileMap?.join("");
    var encryptedMobile = "**".concat(discardedMobileString, mobileNo?.slice(6, mobileNo?.length));


    const backToPage = () => {
        if(location?.state?.postlogin == true){
            navigate("/personal-details")
        }else{
            navigate("/")

        }
    }

    const onClosePopUp = () => {
        setFailurePopUpModal(false);
    }

    return (
        <>
            {failurePopUpModal ? <FailurePopUp
                onClick={() => onClosePopUp()}
                visible={failurePopUpModal}
                setFailureModalStat={setFailurePopUpModal}
                failurePopUpContent={failurePopUpContent}
            /> : null}
            {okButtonPopUpFlag ? <OkButtonPopUp
                // onClick={(e) => {onCloseOkbutton(e,"closeopup");navigatePage(e,"navigate")}}
                onClick={() => {
                    navigate("/personal-details")
                }}
                visible={okButtonPopUpFlag}
                setModalStat={setOkButtonPopUpFlag}
                Content={okButtonPopUpContent} /> : null}
            <RadientBorder className='validate-otp-container-border'>
                <div className='validate-otp-container'>
                    <div className='validate-otp-backbtn-container' onClick={backToPage}>
                        <Button className='validate-otp-backbtn'>
                            <img src={"assets/images/backButtonArrow.svg"}
                                alt="backButtonArrow" />
                            <label>Back</label>
                        </Button>
                    </div>

                    <div className='validate-otp-otpcontainer'>
                        <div className='validate-otp-heading'>
                            <span>Enter OTP</span>
                            <div className='heading-border'></div>
                        </div>
                        <div className='validate-otp-message'>
                            We've sent a 6 digit OTP to your registered mobile number ending with {encryptedMobile}
                        </div>
                        <div className='validate-otp-time'>
                            OTP Valid for {otpTimer} secs
                        </div>
                        <div className="validation-otp-enter-container">
                            <OTPInput
                                value={otp}
                                onChange={handleChange}
                                numInputs={6}
                                separator={<span style={{ width: "15px" }}></span>}
                                isInputNum={true}
                                shouldAutoFocus={true}
                                isInputSecure={true}
                                inputStyle={{
                                    border: "none",
                                    outline: "none",
                                    borderBottom: "1px solid #95A5BF",
                                    width: "100%",
                                    height: "40px",
                                    fontSize: "16px",
                                    fontWeight: "400",
                                    caretColor: "blue",
                                }}
                            />
                            {
                                otpError ? <div className="validate-otp-otpError">{otpError}</div> : null
                            }
                        </div>
                        <div className='validate-otp-verify-message'>
                            Didn't receive any OTP? {otpTimer === 0 ? <span className='resend-now' onClick={validateOtpResendHandler}> Resend Now</span> : <span className=' '>Resend Now</span>}
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
            </RadientBorder>
        </>
    )
}

export default ValidateOtp;